import {
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';

import { TicketWidgetLoaderService } from './ticket-widget-loader.service';

/**
 * Инстанцирует загрузчик виджета билетов при старте приложения — его конструктор
 * инжектит скрипт виджета (side-effect, см. TicketWidgetLoaderService).
 */
export function provideTicketWidgetLoader(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAppInitializer(() => {
      inject(TicketWidgetLoaderService);
    }),
  ]);
}
